import * as React from 'react'
import { classnames } from '@halo/_utils/classnames'
import { FlagsList } from '@halo/portals/post-auth/flags/flags-list'

export const Flags = (props: any) => {
    return (
        <div className={classnames('flags-page')}>
            <FlagsList />
        </div>
    )
}
